import { render, staticRenderFns } from "./unlocked_hint.vue?vue&type=template&id=5c8ae498&scoped=true&"
import script from "./unlocked_hint.vue?vue&type=script&lang=ts&"
export * from "./unlocked_hint.vue?vue&type=script&lang=ts&"
import style0 from "./unlocked_hint.vue?vue&type=style&index=0&id=5c8ae498&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ae498",
  null
  
)

export default component.exports